/**
 * kellykilby-variant.js
 *
 * Size selector behaviour: no size is preselected when the page first loads.
 * While no size is chosen, the add-to-cart button is disabled and shows a
 * "choose a size" label. Once the shopper picks a size, the theme's own
 * variant flow takes over (price, availability, bold/underlined selection).
 *
 * The size radios are rendered `checked` by Liquid so that the theme's async
 * product re-render keeps the selection after a click. We only clear that
 * preselection on the very first load, before any user interaction. A single
 * delegated change listener on `document` survives the theme's HTML swaps of
 * <variant-selects>.
 *
 * Works alongside the theme's <product-form> / <product-info> custom elements
 * without touching the minified theme bundle.
 */
(function () {
  'use strict';

  var CHOOSE_SIZE_STRING =
    (window.theme && window.theme.strings && window.theme.strings.chooseSize) ||
    'Choose a size';

  function getProductForm(scope) {
    return scope ? scope.querySelector('product-form') : null;
  }

  function disableSubmit(productForm) {
    if (!productForm) return;
    if (typeof productForm.toggleSubmitButton === 'function') {
      productForm.toggleSubmitButton(true, CHOOSE_SIZE_STRING);
    }
    // Prevent the default Shopify variant from being added before a choice.
    var idInput = productForm.querySelector('input[name="id"]');
    if (idInput) idInput.setAttribute('disabled', 'disabled');
  }

  // First load only: uncheck the preselected size and disable add-to-cart.
  function clearPreselection(productInfo) {
    if (!productInfo || productInfo.dataset.kkSizeTouched === 'true') return;

    var variantSelects = productInfo.querySelector('variant-selects[data-no-size-preselect]');
    if (!variantSelects) return;

    var sizeInputs = variantSelects.querySelectorAll('.kk-size-fieldset input[type="radio"]');
    if (!sizeInputs.length) return;

    var changed = false;
    sizeInputs.forEach(function (input) {
      if (input.checked) {
        input.checked = false;
        changed = true;
      }
    });

    if (changed) disableSubmit(getProductForm(productInfo));
  }

  function initAll() {
    document
      .querySelectorAll('product-info:has(variant-selects[data-no-size-preselect])')
      .forEach(clearPreselection);
  }

  // Fallback for browsers without :has() — scan variant-selects directly.
  function initAllFallback() {
    document
      .querySelectorAll('variant-selects[data-no-size-preselect]')
      .forEach(function (vs) {
        clearPreselection(vs.closest('product-info'));
      });
  }

  function run() {
    try {
      initAll();
    } catch (e) {
      initAllFallback();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run on initial product-info load (covers async-rendered sections).
  document.addEventListener('theme:product-info:loaded', run);

  // Single delegated listener: survives the theme's <variant-selects> swaps.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest) return;
    if (!input.closest('.kk-size-fieldset')) return;

    var productInfo = input.closest('product-info');
    if (!productInfo) return;

    // Mark as touched so later re-renders keep the selection.
    productInfo.dataset.kkSizeTouched = 'true';

    // Re-enable the variant id input; the theme handles price/availability.
    var productForm = getProductForm(productInfo);
    var idInput = productForm && productForm.querySelector('input[name="id"]');
    if (idInput) idInput.removeAttribute('disabled');
  });
})();
